import React, { useEffect } from "react";
import Header from "../Header/Header";
// import bg from "../../../img/bg2.png";
// import anime from "animejs";
import img1 from "../../../img/sub4.png";
import img2 from "../../../img/sub3.png";
import img3 from "../../../img/sub2.png";
import img4 from "../../../img/sub1.png";
import img5 from "../../../img/HEARINGTESTS.png";
import img6 from "../../../img/mask3.png";
import img7 from "../../../img/mask2.png";
import img8 from "../../../img/mask1.png";
import whare from "../../../img/wh.png";
import Phonak1 from "../../../img/Phonak3.png";
import Phonak2 from "../../../img/Phonak2.png";
import Phonak3 from "../../../img/Phonak1.png";
import Phonak4 from "../../../img/Phonak4.png";
import Trusted3 from "../../../img/Trusted3.png";
import Trusted2 from "../../../img/Trusted2.png";
import Trusted4 from "../../../img/Trusted1.png";
import Trusted1 from "../../../img/Trusted4.png";
import Awards1 from "../../../img/Awards1.png";
import Awards2 from "../../../img/Awards2.png";
import Awards3 from "../../../img/Awards3.png";
import Awards4 from "../../../img/Awards4.png";
// import group from "../../../img/group.png";
import Group2 from "../../../img/Group2.png";
import blog2 from "../../../img/blog2.png";
import blog1 from "../../../img/blog1.png";
// import linked from "../../../img/s2.png";
// import insta from "../../../img/s1.png";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import LinksPage from "../LinkPage/LinksPage";

import ReactPlayer from "react-player";
import Footer from "../Footer/Footer";
import { Helmet } from 'react-helmet-async';

function Home() {
  // const navigate = useNavigate();
  // useEffect(() => {
  //   if (localStorage.getItem("access_token")) {
  //     navigate("/");
  //   }
  // }, []);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
       <Helmet>
        <title>Best Hearing Aid Singapore | Hearing Aids Singapore</title>
        <meta name="description" content="Struggling to hear clearly? Our high-quality hearing aid products and services at The Hearing Centre can help! Book your consultation now!" />
        <meta property="og:title" content="Best Hearing Aid Singapore | Hearing Aids Singapore"></meta>
        <meta property="og:description" content="Struggling to hear clearly? Our high-quality hearing aid products and services at The Hearing Centre can help! Book your consultation now!"></meta>
    </Helmet>
      <Header />
      <section className="Benner_section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="banner_text">
                <h6 className="wow  fadeInUp  animated">
                  Improve Your Hearing Now!
                </h6>
                <h1 className="wow zoomIn  animated">
                  Renowned For Expertise, Chosen For Care.
                </h1>
                <div className="Button_div">
                  <Link to="/contact">
                    <button className="btn wow  slideInUp animated">
                      Contact Now!
                    </button>
                  </Link>

                  <p>
                    Learn More &nbsp; &nbsp; &nbsp;
                    <svg
                      className="ml-1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="24"
                      viewBox="0 0 35 24"
                      fill="none"
                    >
                      <path
                        d="M2 10.5C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8284 1.17157 13.5 2 13.5L2 10.5ZM34.0607 13.0607C34.6464 12.4749 34.6464 11.5251 34.0607 10.9393L24.5147 1.3934C23.9289 0.807613 22.9792 0.807613 22.3934 1.3934C21.8076 1.97919 21.8076 2.92893 22.3934 3.51472L30.8787 12L22.3934 20.4853C21.8076 21.0711 21.8076 22.0208 22.3934 22.6066C22.9792 23.1924 23.9289 23.1924 24.5147 22.6066L34.0607 13.0607ZM2 13.5L33 13.5L33 10.5L2 10.5L2 13.5Z"
                        fill="#ED7C95"
                      />
                    </svg>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="benner_img"></div>
            </div>
          </div>
        </div>
      </section>
      {/* 
      What We Provide */}

      <section className="What_Provide">
        <div className="container">
          <h1 className="Heading_text wow  zoomIn animated">What We Provide</h1>
          <div className="row wow  fadeInUp animated">
            <div className="col-md-3">
              <Link to="/Services/Hearing-Services">
                <div class="card">
                  <img src={img1} class="card-img-top" alt="..." />

                  <div className="pose_img">
                    <img src={img5} class="img-fluid" alt="..." />
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">HEARING TESTS</h5>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-md-3">
              <Link to="/Services/Hearing-Implants">
                <div class="card">
                  <img src={img2} class="card-img-top" alt="..." />

                  <div className="pose_img">
                    <img src={img6} class="img-fluid" alt="..." />
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">HEARING IMPLANTS </h5>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-md-3">
              <Link to="/Services/Ear-Measurements">
                <div class="card">
                  <img src={img3} class="card-img-top" alt="..." />

                  <div className="pose_img">
                    <img src={img7} class="img-fluid" alt="..." />
                  </div>
                  <div class="card-body">
                    <h5 class="card-title"> EAR MEASUREMENTS</h5>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-md-3">
              <Link to="/Services/hearing-aid-repairs-and-adjustments">
                <div class="card">
                  <img src={img4} class="card-img-top" alt="..." />

                  <div className="pose_img">
                    <img src={img8} class="img-fluid" alt="..." />
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">REPAIRS & ADJUSTMENTS</h5>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* WHO WE ARE */}

      <section className="WHO_WE_ARE">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="who_text">
                <h6 className="wow  fadeInUp animated">WHO WE ARE</h6>
                <h1 className="wow  slideInLeft animated">
                  Quality Hearing Aids
                  <br />
                  Provider in Singapore
                </h1>
                <p className="wow fadeInUp animated">
                  The Hearing Centre has been a pioneer in providing the best
                  <b> hearing aids</b> in Singapore for more than 20 years. We
                  take pride in the quality of service and hearing aid care that
                  we provide across all our 7 centres islandwide. We have a team
                  of audiologists who have over 15+ years of experience in
                  providing hearing aid care and dealing with patients who have
                  mild to profound hearing loss.
                </p>
                <p className="wow fadeInUp animated">
                  We, at The Hearing Centre Singapore, understand that there is
                  no one-size-fits-all hearing aids in the market, hence we do
                  our best to provide the most suitable customized solutions to
                  all our patients.
                </p>

                <p className="wow fadeInUp animated">
                  With a strong suit in hearing loss healthcare for almost two
                  decades, The Hearing Centre recognizes all the existing
                  distress, fear and worries that dwell in people who tend to
                  suffer hearing loss themselves or for their loved ones, and
                  thus, we strive to boost their appreciation for the value of
                  hearing while re-kindling their life’s joy of hearing and
                  communicating.
                </p>
                <Link to="/About">
                  <button className="btn wow  slideInUp animated">
                    Read More
                  </button>
                </Link>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="img_whare wow fadeInRight Lato animated">
                <img src={whare} class="img-fluid" alt="..." />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Lumity models */}

      <section className="Explore_Lumity_models">
        <div className="container">
          <h1 className="Heading_text wow  zoomIn animated">Product</h1>
          <ul className="card_listing wow  fadeInRight animated">
            <li className="">
              <div className="card">
                <div className="card_box"></div>
                <img src={Phonak1} alt="Phonak" />
                <h6>Phonak Hearing Aid</h6>
                <p>
                  Bringing The Unparalleled Hearing Solutions To People's Lives
                  One Of The Most Sought-After Sonova Brands.
                </p>
                <Link to="/Products/Phonak-Hearing">
                  <button className="btn">Call to Action</button>
                </Link>{" "}
              </div>
            </li>
            <li className="">
              <div className="card">
                <div className="card_box"></div>
                <img src={Phonak2} alt="Phonak" />
                <h6>Signia Hearing Aids</h6>
                <p>
                  A World-Class Hearing Aid Brand That Transforms Your Weakness
                  Into Your Biggest Strength!
                </p>
                <Link to="/Products/signia-hearing-aids-the-hearing-centre-singapore">
                  <button className="btn">Call to Action</button>
                </Link>{" "}
              </div>
            </li>
            <li className="">
              {" "}
              <div className="card">
                <div className="card_box"></div>
                <img src={Phonak3} alt="Phonak" />
                <h6>ReSound</h6>
                <p>
                  GN ReSound: Setting Standards In The Hearing Aid Industry A
                  Pioneering Brand That Has Set Benchmarks With Its Cutting Edge
                  Hearing Technology!
                </p>
                <Link to="/Products/resound-hearing-aid">
                  <button className="btn">Call to Action</button>
                </Link>{" "}
              </div>
            </li>
            <li className="">
              <div className="card">
                <div className="card_box"></div>
                <img src={Phonak4} alt="Phonak" />
                <h6>Starkey Hearing Aids</h6>
                <p>
                  Starkey Hearing Technologies is an American privately owned
                  company based in Eden Prairie, Minnesota that makes hearing
                  aids
                </p>
                <Link to="/Products/starkey-hearing-aids">
                  <button className="btn">Call to Action</button>
                </Link>{" "}
              </div>
            </li>
          </ul>
        </div>
      </section>

      {/* Our Trusted Partners */}
      <section className="ETrusted_Partnerss">
        <div className="container">
          <h1 className="Heading_text wow  zoomIn animated">
            Our Trusted Partners{" "}
          </h1>
          <ul className="Etrusted_img wow  fadeInRight animated">
            <li>
              {" "}
              <img src={Trusted1} className="img-fluid" alt="Trusted" />
            </li>
            <li>
              {" "}
              <img src={Trusted2} className="img-fluid" alt="Trusted" />
            </li>
            <li>
              {" "}
              <img src={Trusted3} className="img-fluid" alt="Trusted" />
            </li>
            <li>
              {" "}
              <img src={Trusted4} className="img-fluid" alt="Trusted" />
            </li>
          </ul>
        </div>
      </section>

      {/* Our Recognition, Achievements and Awards */}
      <section className="Achievements_Awards">
        <div className="container">
          <h1 className="Heading_text wow  zoomIn animated">
            Our Recognition, Achievements and Awards{" "}
          </h1>

          <div className="silder_box wow  zoomInUp animated">
            <Slider {...settings}>
              <div>
                <img src={Awards1} className="img-fluid" alt="Awards1" />
              </div>
              <div>
                <img src={Awards2} className="img-fluid" alt="Awards1" />
              </div>
              <div>
                <img src={Awards3} className="img-fluid" alt="Awards1" />
              </div>
              <div>
                <img src={Awards4} className="img-fluid" alt="Awards1" />
              </div>
              <div>
                <img src={Awards1} className="img-fluid" alt="Awards1" />
              </div>
              <div>
                <img src={Awards2} className="img-fluid" alt="Awards1" />
              </div>
            </Slider>
          </div>

          <div className="Achievent_div wow  fadeInRight animated">
            <div className="Achievent_card">
              <h6>Award (2020)</h6>
              <div className="aw_text">
                <div>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30611 0H33.6759C33.6871 0.660901 33.6825 1.43818 33.657 2.30272H37.3354C41.4143 2.30272 42.1325 5.37287 41.9818 6.90794C41.0094 22.9515 30.8824 27.0593 25.7209 27.1372L27.4671 33.6345C28.7966 33.6756 31.4555 34.572 31.4555 37.8286V41.9815H10.5676V37.8286C10.4717 36.5539 11.1104 33.9306 14.4327 33.6345L16.3084 27.1102C3.37052 25.9584 0.0410408 13.1983 0.000283029 6.90794C-0.0326114 3.09219 2.81001 2.2479 4.23544 2.30272H8.265H8.33493C8.316 1.55837 8.30611 0.790927 8.30611 0ZM8.5534 6.53761H4.07098C4.07098 16.4898 9.81526 21.0372 12.8945 22.1674L12.7469 21.957C11.5252 20.6222 9.29513 15.8553 8.5534 6.53761ZM29.3214 21.8205C35.7645 20.0657 37.6521 10.9311 37.7877 6.53761H33.3966C32.921 11.6864 31.7658 17.9025 29.3214 21.8205Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <p> Outstanding Business Partnership Award</p>
              </div>
            </div>

            <div className="Achievent_card">
              <h6>2018-2019</h6>
              <div className="aw_text">
                <div>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30611 0H33.6759C33.6871 0.660901 33.6825 1.43818 33.657 2.30272H37.3354C41.4143 2.30272 42.1325 5.37287 41.9818 6.90794C41.0094 22.9515 30.8824 27.0593 25.7209 27.1372L27.4671 33.6345C28.7966 33.6756 31.4555 34.572 31.4555 37.8286V41.9815H10.5676V37.8286C10.4717 36.5539 11.1104 33.9306 14.4327 33.6345L16.3084 27.1102C3.37052 25.9584 0.0410408 13.1983 0.000283029 6.90794C-0.0326114 3.09219 2.81001 2.2479 4.23544 2.30272H8.265H8.33493C8.316 1.55837 8.30611 0.790927 8.30611 0ZM8.5534 6.53761H4.07098C4.07098 16.4898 9.81526 21.0372 12.8945 22.1674L12.7469 21.957C11.5252 20.6222 9.29513 15.8553 8.5534 6.53761ZM29.3214 21.8205C35.7645 20.0657 37.6521 10.9311 37.7877 6.53761H33.3966C32.921 11.6864 31.7658 17.9025 29.3214 21.8205Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <p> Outstanding Audiology Practice</p>
              </div>
            </div>

            <div className="Achievent_card">
              <h6>2018-2019</h6>
              <div className="aw_text">
                <div>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30611 0H33.6759C33.6871 0.660901 33.6825 1.43818 33.657 2.30272H37.3354C41.4143 2.30272 42.1325 5.37287 41.9818 6.90794C41.0094 22.9515 30.8824 27.0593 25.7209 27.1372L27.4671 33.6345C28.7966 33.6756 31.4555 34.572 31.4555 37.8286V41.9815H10.5676V37.8286C10.4717 36.5539 11.1104 33.9306 14.4327 33.6345L16.3084 27.1102C3.37052 25.9584 0.0410408 13.1983 0.000283029 6.90794C-0.0326114 3.09219 2.81001 2.2479 4.23544 2.30272H8.265H8.33493C8.316 1.55837 8.30611 0.790927 8.30611 0ZM8.5534 6.53761H4.07098C4.07098 16.4898 9.81526 21.0372 12.8945 22.1674L12.7469 21.957C11.5252 20.6222 9.29513 15.8553 8.5534 6.53761ZM29.3214 21.8205C35.7645 20.0657 37.6521 10.9311 37.7877 6.53761H33.3966C32.921 11.6864 31.7658 17.9025 29.3214 21.8205Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <p> Best In Success Rate In Fitting</p>
              </div>
            </div>
            <div className="Achievent_card">
              <h6>2019</h6>
              <div className="aw_text">
                <div>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30611 0H33.6759C33.6871 0.660901 33.6825 1.43818 33.657 2.30272H37.3354C41.4143 2.30272 42.1325 5.37287 41.9818 6.90794C41.0094 22.9515 30.8824 27.0593 25.7209 27.1372L27.4671 33.6345C28.7966 33.6756 31.4555 34.572 31.4555 37.8286V41.9815H10.5676V37.8286C10.4717 36.5539 11.1104 33.9306 14.4327 33.6345L16.3084 27.1102C3.37052 25.9584 0.0410408 13.1983 0.000283029 6.90794C-0.0326114 3.09219 2.81001 2.2479 4.23544 2.30272H8.265H8.33493C8.316 1.55837 8.30611 0.790927 8.30611 0ZM8.5534 6.53761H4.07098C4.07098 16.4898 9.81526 21.0372 12.8945 22.1674L12.7469 21.957C11.5252 20.6222 9.29513 15.8553 8.5534 6.53761ZM29.3214 21.8205C35.7645 20.0657 37.6521 10.9311 37.7877 6.53761H33.3966C32.921 11.6864 31.7658 17.9025 29.3214 21.8205Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <p> Trailblazer Award</p>
              </div>
            </div>

            <div className="Achievent_card">
              <h6>2016-2018</h6>

              <div className="aw_text">
                <div>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30611 0H33.6759C33.6871 0.660901 33.6825 1.43818 33.657 2.30272H37.3354C41.4143 2.30272 42.1325 5.37287 41.9818 6.90794C41.0094 22.9515 30.8824 27.0593 25.7209 27.1372L27.4671 33.6345C28.7966 33.6756 31.4555 34.572 31.4555 37.8286V41.9815H10.5676V37.8286C10.4717 36.5539 11.1104 33.9306 14.4327 33.6345L16.3084 27.1102C3.37052 25.9584 0.0410408 13.1983 0.000283029 6.90794C-0.0326114 3.09219 2.81001 2.2479 4.23544 2.30272H8.265H8.33493C8.316 1.55837 8.30611 0.790927 8.30611 0ZM8.5534 6.53761H4.07098C4.07098 16.4898 9.81526 21.0372 12.8945 22.1674L12.7469 21.957C11.5252 20.6222 9.29513 15.8553 8.5534 6.53761ZM29.3214 21.8205C35.7645 20.0657 37.6521 10.9311 37.7877 6.53761H33.3966C32.921 11.6864 31.7658 17.9025 29.3214 21.8205Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <p> Best In Customer Satisfaction</p>
              </div>
            </div>

            <div className="Achievent_card">
              <h6>2014</h6>
              <div className="aw_text">
                <div>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30611 0H33.6759C33.6871 0.660901 33.6825 1.43818 33.657 2.30272H37.3354C41.4143 2.30272 42.1325 5.37287 41.9818 6.90794C41.0094 22.9515 30.8824 27.0593 25.7209 27.1372L27.4671 33.6345C28.7966 33.6756 31.4555 34.572 31.4555 37.8286V41.9815H10.5676V37.8286C10.4717 36.5539 11.1104 33.9306 14.4327 33.6345L16.3084 27.1102C3.37052 25.9584 0.0410408 13.1983 0.000283029 6.90794C-0.0326114 3.09219 2.81001 2.2479 4.23544 2.30272H8.265H8.33493C8.316 1.55837 8.30611 0.790927 8.30611 0ZM8.5534 6.53761H4.07098C4.07098 16.4898 9.81526 21.0372 12.8945 22.1674L12.7469 21.957C11.5252 20.6222 9.29513 15.8553 8.5534 6.53761ZM29.3214 21.8205C35.7645 20.0657 37.6521 10.9311 37.7877 6.53761H33.3966C32.921 11.6864 31.7658 17.9025 29.3214 21.8205Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <p>Outstanding Business Partnership Awards</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT WE DO ? */}

      <section className="WHAT_WE_DO">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="img_whare wow fadeInLeft animated">
                <img src={whare} class="img-fluid" alt="..." />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="WHAT_text">
                <h6 className="wow fadeInUp animated">WHAT WE DO ?</h6>
                <h1 className="wow slideInRight animated">
                  Unsurpassed Passion and <br />
                  Commitment to Overcome <br />
                  Hearing Loss
                </h1>
                <p className="fadeInRight wow animated">
                  With the vision to empower our patient’s hearing capabilities,
                  The Hearing Centre Singapore aims to not only be a hearing aid
                  service provider to our patients but also to treat all
                  patients as our valuable extended family members.
                </p>

                <p className="fadeInRight wow animated">
                  Our vision is to therefore provide an extraordinary hearing
                  experience that surpasses all others while bringing smiles to
                  the faces of our newfound family members. Right from
                  consultation and counseling to various assessments, fittings
                  of hearing aids to post-fitting care and support, we strive to
                  nurture with excellence in every situation in terms of
                  expertise and care and have since become a world-class
                  provider of top-grade hearing aids brands across the globe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Satisfaction Guarantee */}

      <section className="Satisfaction">
        <div className="container">
          <h5 className="wow  zoomIn  animated">
            Satisfaction Guarantee <br />
            Our Customer Testimonials
          </h5>
          <div className="row wow  fadeInUp animated">
            <div className="col-lg-4 col-md-12">
              <ReactPlayer
                width="425px"
                height="300px"
                url="https://www.youtube.com/embed/q7Lf236UiJc?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                className="video_div"
              />
            </div>

            <div className="col-lg-4 col-md-12">
              <ReactPlayer
                width="425px"
                height="300px"
                url="https://www.youtube.com/embed/LxhBU6L_Rpk?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                className="video_div"
              />
            </div>

            <div className="col-lg-4 col-md-12">
              <ReactPlayer
                width="425px"
                height="300px"
                url="https://www.youtube.com/embed/DkZWgcxjWug?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                className="video_div"
              />
            </div>
          </div>
        </div>
      </section>

      {/* WHAT WE DO ? */}

      <section className="WHO_WE_ARE">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="who_text">
                <h6 className="wow  fadeInUp animated">WHAT WE DO ?</h6>
                <h1 className="wow  slideInLeft animated">
                  Revelation of the Wonders
                  <br />
                  of Hearing Aids
                </h1>
                <p className="wow fadeInUp animated">
                  People suffering from hearing loss usually find listening and
                  understanding speech to be difficult, especially when there is
                  background noise. So it is usually advisable for them to start
                  wearing hearing aids for their needs and lifestyle.
                </p>
                <p className="wow fadeInUp animated">
                  A hearing aid is a device used to regulate and amplify sound
                  for people with partial deafness. It will help to improve the
                  quality of life, but it should be noted that they are not
                  meant to cure nor help people with complete deafness. There
                  are different types of hearing aids that can either be worn on
                  the ear or within the ear itself, and you can get them from
                  hearing aid specialists like us, The Hearing Centre Singapore.
                </p>

                <p className="wow fadeInUp animated">
                  When choosing a hearing aid, you will first have to visit an
                  audiologist to get your hearing assessed. While they all serve
                  the same purpose, the type of hearing aid that is recommended
                  to you would depend on your lifestyle.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="img_whare wow fadeInRight  animated">
                <img src={Group2} class="img-fluid" alt="..." />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Basics of Hearing Aids */}

      <section className="Basics_Hearing">
        <div className="container">
          <h1 className="Heading_text wow  fadeInUp animated">
            Basics of Hearing Aids
          </h1>
          <p className="head_pergrap wow fadeInUp animated">
            How hearing aids work is that they have 4 basic components that
            confer their functions:
          </p>

          <div className="row  Hearing_Aids slideInLeft wow animated">
            <div className="col-lg-3 col-md-6">
              <div className="box_basics">
                <p>
                  The microphone picks up the sounds in the environment and
                  passes them to the processor.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="box_basics">
                <p>
                  The processor enhances the signal and delivers it to the
                  receiver
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="box_basics">
                <p>
                  The receiver delivers the amplified sound to the ear canal.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="box_basics">
                <p>
                  The power source refers to the battery, which drives the
                  hearing aids system.
                </p>
              </div>
            </div>
          </div>

          <p className="head_pergrap wow fadeInUp animated">
            With the advancement in hearing aid technology, these basic parts
            have transformed into 4 sophisticated components. The sound picked
            up by the microphone can now be converted from analog to digital
            before processing, then converted back from digital to analog by the
            processor before the receiver delivers the enhanced sound into the
            ear canal.
          </p>
          <p className="head_pergrap wow fadeInUp animated">
            This technology has driven digital hearing aids to perform multiple
            sound processing and management tasks simultaneously and more
            efficiently. As with all other electronic devices, the battery is
            the main power source driving the hearing aids system.
          </p>
        </div>
      </section>

      {/* Latest Blog */}

      <section className="Latest_Blog">
        <div className="container">
          <h1 className="Heading_text wow  fadeInUp animated">Latest Blog</h1>

          <div className="row wow  fadeInUp animated">
            <div className="col-md-6">
              <div class="card">
                <img src={blog2} class="card-img-top" alt="..." />
                <h6>7 Common Myths About Hearing Aids</h6>
                <p>
                  7 Common Myths About Hearing Aids Hearing Aids are
                  sophisticated electronic devices that a person with hearing
                  loss can use to help them hear better again. But the decision
                  to purchase and use one is often met with resistance because
                  of misinformation. In this blog article.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div class="card">
                <img src={blog1} class="card-img-top" alt="..." />
                <h6>7 Common Myths About Hearing Aids</h6>
                <p>
                  7 Common Myths About Hearing Aids Hearing Aids are
                  sophisticated electronic devices that a person with hearing
                  loss can use to help them hear better again. But the decision
                  to purchase and use one is often met with resistance because
                  of misinformation. In this blog article.
                </p>
              </div>
            </div>
          </div>
          <div className="Btn_box wow  slideInUp animated">
            <Link to="/Blogs">
              <button className="btn">+ Read More</button>
            </Link>
          </div>
        </div>
      </section>

      {/* Call for an appointment */}

      <section className="Call_appointment">
        <div className="bg_img_call "></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="Call_text ">
                <p className="wow  fadeInLeft animated">
                  Call for an appointment!
                </p>
                <h1>+65 6474 2216 | +65 9776 7615</h1>
              </div>

              <div className="Call_text">
                <p className="wow  fadeInLeft animated">Send an Email</p>
                <h1>enquiry@thehearingcentre.sg</h1>
              </div>
            </div>

            <div className="col-lg-4 col-md-12"></div>
            <div className="col-lg-4 col-md-12">
              <div className="Call_text ">
                <p className="fadeInRight wow  animated">
                  Find a clinic near you, Find Us On Map
                </p>
                <ul>
                  <li>
                    <p>Lucky Plaza - Main Branch,</p>
                    <p>Pasir Ris Branch, ,</p>
                    <p>North Bridge Road,</p>
                    <p>Ang Mo Kio Branch</p>
                  </li>
                  <li>
                    <p>Tampines Branch, ,</p>
                    <p>East Coast Branch,</p>
                    <p>Jurong (IMM) Branch,</p>
                    <p>Cambodia Branch</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Home;
